export default "__VITE_ASSET__B9hCnLdv__"